export interface PdfFieldConfig {
    key: string;            // Form control name (e.g., 'fullName')
    label: string;          // Display label
    type: 'text' | 'date' | 'number' | 'checkbox' | 'select';
    required: boolean;
    options?: string[];     // For select type
    validators?: {
        pattern?: string;     // Regex
        minLength?: number;
        maxLength?: number;
    };
    ui: {
        page: number;         // Page number to render on
        x: number;            // X percent (0-100) or px
        y: number;            // Y percent (0-100) or px
        width: number;        // Width in px
        height: number;       // Height in px
        placeholder?: string;
    };
}
 
export const PDF_SCHEMAS: Record<string, PdfFieldConfig[]> = {
    'uniformRequirements': [
        {
            key: 'fullName',
            label: 'Full Name',
            type: 'text',
            required: true,
            ui: { page: 1, x: 140, y: 150, width: 200, height: 30, placeholder: 'Enter full name' }
        },
        {
            key: 'date',
            label: 'Date',
            type: 'date',
            required: true,
            ui: { page: 1, x: 400, y: 150, width: 150, height: 30 }
        },
        {
            key: 'signature',
            label: 'Signature',
            type: 'text',
            required: true,
            ui: { page: 1, x: 140, y: 200, width: 200, height: 60 }
        }
    ],
    'participatingAgreement': [
        {
            key: 'vendorName',
            label: 'Vendor Name',
            type: 'text',
            required: true,
            ui: { page: 3, x: 100, y: 100, width: 250, height: 30 }
        },
        {
            key: 'date',
            label: 'Agreement Date',
            type: 'date',
            required: true,
            ui: { page: 3, x: 440, y: 480, width: 150, height: 30 }
        },
        {
            key: 'signature',
            label: 'Signature',
            type: 'text',
            required: true,
            ui: { page: 3, x: 57, y: 470, width: 376, height: 48 }
        }
    ],
    'W9': [
        {
            key: 'name',
            label: 'Name (as shown on your income tax return)',
            type: 'text',
            required: true,
            ui: { page: 1, x: 50, y: 180, width: 400, height: 25 }
        },
        {
            key: 'businessName',
            label: 'Business Name',
            type: 'text',
            required: false,
            ui: { page: 1, x: 50, y: 230, width: 400, height: 25 }
        },
        {
            key: 'date',
            label: 'Date',
            type: 'date',
            required: true,
            ui: { page: 1, x: 420, y: 540, width: 150, height: 25 }
        },
        {
            key: 'signature',
            label: 'Signature',
            type: 'text',
            required: true,
            ui: { page: 1, x: 82, y: 524, width: 260, height: 58 }
        }
    ],
    'corporateAuthorityForm': [
        {
            key: 'date',
            label: 'Date',
            type: 'date',
            required: true,
            ui: { page: 1, x: 403, y: 535, width: 120, height: 24 }
        },
        {
            key: 'signature',
            label: 'Signature',
            type: 'text',
            required: true,
            ui: { page: 1, x: 100, y: 538, width: 276, height: 48 }
        }
    ]
};